export const colors = {
    name: 'Colors',
    fields: []
};


// WEBPACK FOOTER //
// /mnt/e/apps/architect3/client/node_modules/vebto-client/admin/appearance/config/colors-config.ts